import { validInstance } from "./types";

export const createDBPath = ({ user: { uid }, instance: { id, path } }: validInstance) => [uid, ...path.slice(1), id];
